export default __webpack_public_path__ + "static/media/Emily Slosser.a10875a5.png";